import type React from "react";
import { useEffect, useRef } from "react";

export const useHasUserScrolled = (containerRef: React.RefObject<HTMLDivElement | null>): React.MutableRefObject<boolean> => {
    const userScrolledRef = useRef(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) {
            return;
        }

        const handleScroll = () => {
            const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
            const threshold = 30;
            userScrolledRef.current = distanceFromBottom > threshold;
        };

        container.addEventListener("scroll", handleScroll);
        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, [containerRef]);

    return userScrolledRef;
};
